import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";

const BusinessUnitAPI = {
    getByTenantId(tenantId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/business-units/${tenantId}`
        )
    },
    getAll(){
        return makeCancellableAPIRequest(
            "GET",
            `/user/business-units/`
        )
    },
    get(businessUnitId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/businees-unit/${businessUnitId}`
        )
    },
    getUsers(businessUnitId){
        return makeCancellableAPIRequest(
            "GET",
            `/user/business-units/${businessUnitId}/users`
        )
    },
    create(data){
        return makeCancellableAPIRequest(
            "POST",
            `/business-unit/`,
            { data }
        )
    },
    update(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/business-unit/`,
            { data }
        )
    },
    getRolePermissions(roleName){
        return makeCancellableAPIRequest(
            "GET",
            `/user/businessunit/role/permissions`,
            {
                params: {
                    role: roleName
                }
            }
        )
    },
    getAllPermissions(){
        return makeCancellableAPIRequest(
            "GET",
            `/admin/user/permissions?operation=WRITE,DELETE,READ`,
        )
    },
    updateRolePermissions(data){
        return failSafe(
            APIClient.post(`/admin/user/map/role/permission`,data)
        );
    },
    createRole(data){
        return failSafe(
            APIClient.post(`/admin/user/role`,{
                ...data
            })
        );
    },
    updateRoledetails(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/admin/user/role`,
            {
                data
            }
        )
    },
    getBUListWithAdminAccess(){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenant/businessUnits`
        )
    },
    getAllBUStats(params) {
        return makeCancellableAPIRequest(
            "GET",
            `/user/all-bu-stats`,
            {
                params
            }
        )
    },
    getAppSecStatus(restParams) {
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/appsec-tools/status-aggregated-by`,
            {
                data: {
                    aggregateField: "BU",
                    buIds: [],// this means all the BU
                    ...restParams
                }
            }
        )
    },
    checkIfBuNameExists(params) {
        return makeCancellableAPIRequest(
            "GET",
            `/business-unit/is-name-available`,
            {
                params
            }
        )
    }
}

export default BusinessUnitAPI;